<div class="form-check form-switch">
    <label class="form-check-label form-check-label--paybee " [ngClass]="{'disabled': disabled }"> 
      <input
        mdbCheckbox
        class="form-check-input form-check-input--paybee"
        type="checkbox" 
        #inputName
        [formControl]="controlSwitchName"
        [checked]="value"
      />
      <span [innerHTML]="label"></span>
    </label>
</div>
